import React, { Component } from 'react'
import { Modal, Button, Card, Spinner } from 'react-bootstrap';
import axios from 'axios';
import TextInput from 'react-autocomplete-input';
import 'react-autocomplete-input/dist/bundle.css';

import './StyleModal.css';

class RiceTypeModel extends Component {
    constructor(props) {
      super(props);
      this.state = {
        licenseDetail: [],
        msg: '',
      }
    }
  
    componentWillMount() {
    }
    handleSelect = (e) => {
    }
    handleSelectAll = () => {
    //   this.props.submitAll(this.state.licenseDetail,this.state.companyDescription,
    //     () => {this.props.onHide()} );
    }
    renderList() {
    }
    render() {
      let { msg } = this.state;
      return (
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title id="contained-modal-title-vcenter">
              เพิ่มชนิดข้าว
            </Modal.Title>
  
          </Modal.Header>
          <Modal.Body>

            <TextInput Component='input' regex={''} spacer={''} maxOptions={10} 
            onChange={(e)=>{this.props.handleRiceType(e,this.props.idx)}} className ='form-control' 
            trigger={''} options={this.props.riceForSearch} />

          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={this.props.onHide}>ปิด</Button>
          </Modal.Footer>
        </Modal >
      )
    }
  
  }

export default RiceTypeModel
